<template>
    <span>
        <v-col cols="12">
            <v-avatar
                size="80"
                color="grey"
            >
                <v-icon dark size="80">
                    mdi-account-circle
                </v-icon>
            </v-avatar>
        </v-col>
        <v-col>
            <h3>
                {{ userName }}
            </h3>
        </v-col>
    </span>
</template>

<script>
    export default {
        name: 'UserInfo',
        props: {
            userData: {
                type: Object,
                default: () => {},
            },
        },
        computed: {
            userName () {
                if (this.userData.name) {
                    let fullName = this.userData.name
                    fullName = fullName.charAt(0).toUpperCase() + fullName.slice(1)
                    if (this.userData.surname && this.userData.surname.length > 0) {
                        let surname = this.userData.surname
                        surname = surname.charAt(0).toUpperCase() + surname.slice(1)
                        fullName = fullName + ' ' + surname
                    }
                    return fullName
                } else {
                    return ''
                }
            },
        }
    }
</script>
